module.exports = __webpack_public_path__ + "static/media/Inter-Regular-slnt=0.56786aa1.ttf";